import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom'; // Il contenuto dinamico verrà renderizzato qui
import Menu from "../../components/menu/Menu";
import Navbar from '../../components/menu/Navbar';
import Footer from '../../components/footer/Footer';
import defaultAvatar from '../../static/images/default-avatar.png';

export default function Page() {
    const [isClicked, setIsClicked] = useState(true);
    const [isMode, setIsMode] = useState('dark');
    const [avatar, setAvatar] = useState(localStorage.getItem("avatar") || defaultAvatar);
//"data:image/png;base64,"+
    // Aggiornamento dell'avatar quando cambia lo stato
    useEffect(() => {
        if (avatar) {
            localStorage.setItem("avatar", avatar); // Salva nel localStorage quando cambia
        }
    }, [avatar]);

    // Funzione per gestire il click sul componente Logo
    const handleClick = () => {
        setIsClicked(!isClicked);
    };
    // Funzione per gestire il cambio di modalità
    const handleClickMode = (mode) => {
        setIsMode(mode);
    };

  	return (
        <div className={`${isClicked ? "" : "layout-expand"} layout-wrapper layout-content-navbar ${isMode}`}>
            <div className="layout-container">
                {/* Menu */}
                <Menu onClick={handleClick} isClicked={isClicked} isMode={isMode} />
                <div className="layout-page">
                    {/* Navbar */}
                    <Navbar avatar={avatar} onFirstClick={handleClick} onSecondClick={handleClickMode}  isClicked={isClicked} isMode={isMode}/>
                    {/* Content wrapper */}
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            {/* Main Page*/}
                            <Outlet context={{ setAvatar, avatar }} />
                            {/* /Main Page*/}
                        </div>
                        <Footer />
                    </div>
                    {/* /Content wrapper */}
                </div>
            </div>
        </div>
	);
}